import { Divider, List, ListItem, ListItemText, TextField, Typography } from '@material-ui/core';
import { useBoolean, usePintMaster } from '@lib/common';
import { Fragment, memo, useEffect } from 'react';
import { BadgesMaster } from '@api/masters';
import styled from 'styled-components';
import getLoadingMessage from '@lib/common/loading-messages';
import { Autocomplete } from '@material-ui/lab';
import { useCallback, useMemo, useState } from 'react';
import { Grid, InputLabel, Select, FormControl, Box, Chip, Link, Tooltip } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import { ColoredChipIconButton } from '@components/colored-elements';
import { grey, red } from '@material-ui/core/colors';
import { BiEdit, ImDrawer2, TrashFill } from '@icon/react-icons';
import { useSnackbarInstance } from '@lib/common';

export const BadgeDialogContent = memo<any>(
  ({
    badgesLength,
    onSearch,
    badgeOptions,
    handleBadgeClick,
    defaultValue,
    OkPressed,
    setOkPressed,
  }) => {
    const defaultBadgeAttrs = {};
     const { loading: loading_badges, master: badgeTypes } = usePintMaster("badges_type");
     console.log('badgeTypes', badgeTypes);
     const badgeTypeMap = useMemo(() => {
        return (badgeTypes || []).reduce<Record<number, string>>((acc, type) => {
          acc[type.id] = type.name;
          return acc;
        }, {});
      }, [badgeTypes]);
    if (defaultValue && defaultValue.parameter_values_json)
      Object.keys(defaultValue.parameter_values_json).forEach((x, idx) => {
        defaultBadgeAttrs[idx.toString() + '|0'] = x;
        defaultBadgeAttrs[idx.toString() + '|1'] = defaultValue.parameter_values_json[x];
      });

    const [badgeData, setBadgeData] = useState(
      defaultValue
        ? { ...defaultValue, publish: defaultValue['publish'] ? 'True' : 'False' }
        : { publish: 'True' }
    );
    const [badgeAttr, setBadgeAttr] = useState(defaultBadgeAttrs);

    let defaultArraySizeOfBadges = 0;
    if (
      defaultValue &&
      defaultValue.parameter_values_json &&
      Object.keys(defaultValue.parameter_values_json).length
    ) {
      defaultArraySizeOfBadges = Object.keys(defaultValue.parameter_values_json).length;
    }

    const [indexesAttributes, setIndexesAttributes] = useState(
      Array.from(Array(defaultArraySizeOfBadges || 1), (_, i) => i)
    );
    const [counterAttributes, setCounterAttributes] = useState(defaultArraySizeOfBadges || 1);
    const addAttributes = useCallback(() => {
      setIndexesAttributes(prevIndexes => {
        return [...prevIndexes, counterAttributes];
      });
      setCounterAttributes(prevCounter => prevCounter + 1);
    }, [indexesAttributes, counterAttributes]);

    const removeAttributes = useCallback(index => {
      setIndexesAttributes(prevIndexes => {
        return [...prevIndexes.filter(item => item !== index)];
      });
      setBadgeAttr(prevVal => {
        const oldData = prevVal;
        delete oldData[index + '|0'];
        delete oldData[index + '|1'];
        return { ...oldData };
      });
    }, []);
    const { enqueue } = useSnackbarInstance();

    useEffect(() => {
      if (OkPressed) {
        const errorMsgs = [];
        const badgeAttrs = badgeAttr;
        const preparedBadgeAttr = {};
        if (!badgeData.badge_master_vtr_id) {
          errorMsgs.push('Please select a badge');
        }
        Object.keys(badgeAttrs).forEach(x => {
          
          const firstHalf = x.split('|')[0];
          const secondHalf = x.split('|')[1];
         
          if (secondHalf == '0' && badgeAttrs[firstHalf + '|0']) {
            if (badgeAttrs[firstHalf + '|1'])
              preparedBadgeAttr[badgeAttrs[firstHalf + '|0']] = badgeAttrs[firstHalf + '|1'];
            else {
              errorMsgs.push('One of the badge attribute value is empty');
            }
          } else if (secondHalf == '0' && !badgeAttrs[firstHalf + '|0'] && badgeAttrs[firstHalf + '|0'] != '') {
            errorMsgs.push('One of the badge attribute Key is empty');
          }
        });

        if (!errorMsgs.length)
          handleBadgeClick({
            ...defaultValue,
            ...badgeData,
            publish: badgeData['publish'] === 'True' ? true : false,
            parameter_values_json: preparedBadgeAttr,
          });
        else {
          enqueue(
            <div>
              <Typography>Please correct the following errors</Typography>
              <ul style={{ paddingLeft: '20px' }}>
                {errorMsgs.map((x, idx) => (
                  <li key={idx}>{x}</li>
                ))}
              </ul>
            </div>,
            {
              variant: 'error',
              autoHideDuration: 3000,
            }
          );
          setOkPressed(false);
        }
      }
    }, [OkPressed]);

    // useEffect(() => {
    //   if (value !== categoryTuple) {
    //     setCategoryTuple(value || defaultTuple);
    //   }
    // }, [value]); default value

    return (
      <>
        <Autocomplete
          fullWidth
          filterSelectedOptions
          onChange={(evt, v) => setBadgeData(prevState => ({ ...prevState, ...v }))}
          options={badgeOptions || []}
          defaultValue={defaultValue}
  getOptionLabel={(value: BadgesMaster) => {
    const badgeType = badgeTypeMap[value.badge_types_id];

    return badgeType
      ? `${value.badge_name} (${badgeType})`
      : value.badge_name;
  }}
  getOptionSelected={(option, value) =>
    option.badge_master_vtr_id === value.badge_master_vtr_id
  }
  renderOption={(option: BadgesMaster) => {
    const badgeType = badgeTypeMap[option.badge_types_id];
    console.log('option', option);
    console.log('badgeType', badgeType);
    return (
      <span>
        {option.badge_name}
        {badgeType && (
          <Typography
            component="span"
            color="textSecondary"
            style={{ marginLeft: 6 }}
          >
            ({badgeType})
          </Typography>
        )}
      </span>
    );
  }}
  renderInput={props => (
    <TextField
      helperText="Select badges relevant to the company."
      label="Badges"
      placeholder="Badges"
      fullWidth
      variant="outlined"
      {...props}
    />
  )}
        />
        <br />
        <FormControl variant="outlined" fullWidth>
          <InputLabel id="deal-badge-label">Publish Status</InputLabel>
          <Select
            labelId="deal-badge-label"
            id="deal-badge"
            name="deal_badge"
            native
            label="Publish Status"
            onChange={evt => {
              setBadgeData(prevState => ({ ...prevState, publish: evt.target.value }));
            }}
            defaultValue={
              defaultValue ? (defaultValue && defaultValue.publish ? 'True' : 'False') : 'True'
            }>
            <option value={'False'}>False</option>
            <option value={'True'}>True</option>
          </Select>
        </FormControl>
        <br />
        {/* <button onClick={handleBadgeClick(badgeData)}>OK</button> */}
        <br />
        <Grid container justify="space-between" style={{ marginRight: '30px' }}>
          <Grid item style={{ alignItems: 'center' }}>
            <Typography variant="subtitle1">Badge Attributes</Typography>
          </Grid>
          <Grid item style={{ paddingBottom: '10px' }}>
            <Tooltip title="Add badge attibute">
              <StyledFab onClick={addAttributes} color="primary" aria-label="add" size="small">
                <AddIcon />
              </StyledFab>
            </Tooltip>
          </Grid>
        </Grid>
        {indexesAttributes.length == 0 ? (
          <Typography variant="subtitle2" style={{ fontStyle: 'italic' }}>
            None
          </Typography>
        ) : (
          indexesAttributes.map(indexOfAttribute => {
            const attrIndex = indexOfAttribute.toString() + '|0';
            const attrIndexValue = indexOfAttribute.toString() + '|1';
            return (
              <Grid container spacing={2} style={{ paddingBottom: '10px' }} key={indexOfAttribute}>
                <Grid item xs={5}>
                  <TextField
                    label="Attribute Key"
                    name={attrIndex}
                    value={badgeAttr[attrIndex] ? badgeAttr[attrIndex] : ''}
                    onChange={e =>
                      setBadgeAttr(prevVal => {
                        const newData = {};
                        newData[attrIndex] = e.target.value;
                        return { ...prevVal, ...newData };
                      })
                    }
                  />
                </Grid>
                <Grid item xs={5}>
                  <TextField
                    label="Attribute Value"
                    name={indexOfAttribute.toString() + '1'}
                    value={badgeAttr[attrIndexValue] ? badgeAttr[attrIndexValue] : ''}
                    onChange={e =>
                      setBadgeAttr(prevVal => {
                        const newData = {};
                        newData[attrIndexValue] = e.target.value;
                        return { ...prevVal, ...newData };
                      })
                    }
                  />
                </Grid>
                <Grid item xs={2} style={{ display: 'flex', alignItems: 'center' }}>
                  <Tooltip title="Delete Badge Atrribute">
                    <ColoredChipIconButton
                      onClick={() => removeAttributes(indexOfAttribute)}
                      pointer
                      colored={red[900]}
                      size="small"
                      icon={<TrashFill />}
                    />
                  </Tooltip>
                </Grid>
              </Grid>
            );
          })
        )}
      </>
    );
  }
);
const ListContainer = styled.div`
  height: 47vh;
  border: 1px solid #a1a1a1;
  overflow: auto;
  .list {
    padding: 0;
  }
  .loading {
    padding: 30px;
    display: block;
  }
`;

const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;
